import { render, staticRenderFns } from "./writerApp.vue?vue&type=template&id=4ed2e2a8&scoped=true&"
import script from "./writerApp.vue?vue&type=script&lang=js&"
export * from "./writerApp.vue?vue&type=script&lang=js&"
import style0 from "./writerApp.vue?vue&type=style&index=0&id=4ed2e2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2e2a8",
  null
  
)

export default component.exports